module.exports = __webpack_public_path__ + "static/media/10.7c298451.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/10.jpg
// module id = 65
// module chunks = 0